import React from "react";

import GoogleReviews from "components/GoogleReviews";

import supplyTick from "./../images/supply-tick.svg";
import supplyCross from "./../images/supply-cross.svg";

import "css/QuoteInstaller.css";

const InstallerSupply = ({name, canSupply}) => {
    return (
        <li>
            <span>{name}</span>
            <img src={canSupply ? supplyTick:supplyCross} alt={canSupply? "yes":"no"} />
        </li>
    );
}


const Installer = ({ input, installer, googleReviews, productsToSupply }) => {

    let distance = Math.ceil(installer.drivingDistanceFromRetailCustomer);

    const supplies = productsToSupply.map(product => ({
        id: product.productId,
        name: product.productName,
        canSupply: installer.productsSupplied.some(({ productId }) => productId === product.productId)
    }))

    const canSupplyAllProducts = supplies.filter(({canSupply}) => canSupply).length === supplies.length;


    return (
        <div className={`quote-installer${canSupplyAllProducts ? " quote-installer--supply-all":""}`}>
            <div className="quote-installer__header">
                <img
                    src={
                        "https://apistaging.truframe.co.uk:1986/pricingapi/enquiry/" +
                        installer.guid +
                        "/GetTradeCustomerLogo"
                    }
                    alt="logo"
                />
                <h3>{installer.companyName}</h3>
                <p>
                    {installer.postcode} <small>{distance + " miles"}</small>
                </p>                
            </div>
            <div className="quote-installer__supplies">
                <ul>
                    {supplies.map(supply => <InstallerSupply key={supply.id} {...supply} />)}
                </ul>
            </div>
            <div className="quote-installer__reviews">
                <GoogleReviews reviews={googleReviews} companyName={installer.companyName} />
            </div>
            <div className="quote-installer__selector">
                <input id={input.name} type="checkbox" {...input} checked={input.value} />
                <label htmlFor={input.name} />
            </div>
        </div>
    );
};


export default Installer;


// WEBPACK FOOTER //
// ./src/components/QuoteInstaller.js